import React from "react";
import PageHeader from "@iso/components/utility/pageHeader";
import IntlMessages from "@iso/components/utility/intlMessages";
import Container from "../../components/Container/Container";
import { Collapse } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";

export default function FAQ() {
  const firstPanel = [
    {
      key: "1",
      label: <IntlMessages id="page.faq.panel.1.title" />,
      children: (
        <p>
          <IntlMessages id="page.faq.panel.1.description" />
        </p>
      ),
    },
  ];

  const secondPanel = [
    {
      key: "1",
      label: <IntlMessages id="page.faq.panel.2.1.title" />,
      children: (
        <p>
          <IntlMessages id="page.faq.panel.2.1.description" />
        </p>
      ),
    },
    {
      key: "2",
      label: <IntlMessages id="page.faq.panel.2.2.title" />,
      children: (
        <p>
          <IntlMessages id="page.faq.panel.2.2.description" />
        </p>
      ),
    },
  ];

  return (
    <Container>
      <PageHeader>
        <IntlMessages id="page.faq.title" />
      </PageHeader>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-10 mt-5">
        <div>
          <div className="py-5 px-7 rounded-xl bg-white border-1 shadow-sm">
            <div className="pl-2">
              <h2 className="text-gray-500">
                <IntlMessages id="page.faq.panel.1.theme" />
              </h2>
            </div>
            <Collapse
              expandIconPosition={"end"}
              ghost
              items={firstPanel}
              expandIcon={({ isActive }) => {
                if (isActive) {
                  return <MinusOutlined />;
                }
                return <PlusOutlined />;
              }}
            />
          </div>
        </div>
        <div>
          <div className="py-5 px-7 rounded-xl bg-white border-1 shadow-sm">
            <div className="pl-2">
              <h2 className="text-gray-500">
                <IntlMessages id="page.faq.panel.2.theme" />
              </h2>
            </div>
            <Collapse
              expandIconPosition={"end"}
              ghost
              items={secondPanel}
              expandIcon={({ isActive }) => {
                if (isActive) {
                  return <MinusOutlined />;
                }
                return <PlusOutlined />;
              }}
            />
          </div>
        </div>
      </div>
    </Container>
  );
}
